var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('MainMenu',{ref:"mainmenu"}),_c('v-main',{staticStyle:{"width":"100%"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('ActionSnackbar',{ref:"actionSnackbar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }